import { Grid, HStack, Square, Stack, Text, VStack } from "@chakra-ui/react";
import { usePlanningFilterOptionsQuery } from "@src/__generated__/urql-graphql";
import { ResourcePlanningDndView } from "@src/components/modules/resource-planning/ResourcePlanningDndView";
import { ResourcePlanningFilterRow } from "@src/components/modules/resource-planning/ResourcePlanningFilterRow";
import { AllocationsColumnDay } from "@src/components/modules/resource-planning/timeline/AllocationsColumn";
import { ResourcePlanningDailyViewStoreContext } from "@src/components/modules/resource-planning/timeline/ResourcePlanningDayPage";
import { LoadingOverlay } from "@src/components/ui-kit/LoadingOverlay/LoadingOverlay";
import { COLUMN_HEADER_HEIGHT, COLUMN_WIDTH } from "@src/constants/planning";
import { withCan } from "@src/utils/components/permissions";
import { useStore } from "@src/utils/hooks";
import { format, isToday } from "date-fns";
import { observer } from "mobx-react-lite";
import { type FC, useEffect } from "react";

export const ResourcePlanningWeekPage: FC = withCan(
  { do: "planning_read_own" },
  observer(function ResourcePlanningWeekPage() {
    const { resourcePlanningWeekStore, authStore } = useStore();
    const [{ data: filterOptionsData }] = usePlanningFilterOptionsQuery();

    useEffect(() => {
      if (!filterOptionsData) return;

      resourcePlanningWeekStore.setFilterOptions(filterOptionsData);
    }, [filterOptionsData]);

    useEffect(() => {
      resourcePlanningWeekStore.setUserId(authStore.user!.id);
      resourcePlanningWeekStore.fetchDailyView();
    }, [resourcePlanningWeekStore.selectedDate]);

    return (
      <ResourcePlanningDailyViewStoreContext.Provider
        value={resourcePlanningWeekStore}
      >
        <Stack
          overflow="hidden"
          maxW="full"
          h="full"
          minH="full"
          maxH="full"
          bg="white"
          borderColor="grey.50"
          borderTopWidth="1px"
        >
          <ResourcePlanningFilterRow hideTeamFilter />

          {!!resourcePlanningWeekStore.data && (
            <LoadingOverlay
              maxW="full"
              overflow="scroll"
              h="full"
              maxH="full"
              isLoading={resourcePlanningWeekStore.fetcher.isLoading.value}
            >
              <ResourcePlanningDndView>
                <Grid
                  templateColumns={`repeat(7, minmax(${COLUMN_WIDTH}, 1fr))`}
                  overflow="auto"
                  h="full"
                  minH="full"
                  maxH="full"
                >
                  {resourcePlanningWeekStore.daysOfSelectedInterval.map(
                    (day, index) => {
                      return (
                        <VStack key={day.toISOString()} h="full" bg="white">
                          <HStack
                            pos="sticky"
                            zIndex={11}
                            top="-1px"
                            justifyContent="center"
                            w="full"
                            h={COLUMN_HEADER_HEIGHT}
                            minH={COLUMN_HEADER_HEIGHT}
                            maxH={COLUMN_HEADER_HEIGHT}
                            bg="white"
                            spacing="2"
                          >
                            <Square
                              bg={isToday(day) ? "teal.200" : "grey.100"}
                              rounded="md"
                              size="8"
                            >
                              <Text
                                color={`${isToday(day) ? "teal" : "grey"}.700`}
                                fontSize="md"
                                fontWeight="semibold"
                              >
                                {format(day, "d")}
                              </Text>
                            </Square>
                            <Text
                              color="grey.500"
                              fontSize="xs"
                              fontWeight="semibold"
                            >
                              {format(day, "EEEEEEE")}
                            </Text>
                          </HStack>

                          {resourcePlanningWeekStore.data.map((item) => (
                            <AllocationsColumnDay
                              key={item.user.id}
                              user={item.user}
                              day={item.items[index]}
                            />
                          ))}
                        </VStack>
                      );
                    },
                  )}
                </Grid>
              </ResourcePlanningDndView>
            </LoadingOverlay>
          )}
        </Stack>
      </ResourcePlanningDailyViewStoreContext.Provider>
    );
  }),
);
